import { createReducer, on, Action } from '@ngrx/store';

import * as FeatureActions from './presentation-mode.actions';
import { PresentationModeState } from './presentation-mode.models';

export const PRESENTATION_MODE_KEY = 'presentation-mode';

export interface PresentationModePartialState {
  readonly [PRESENTATION_MODE_KEY]: PresentationModeState;
}

export const initialPresentationModeState: PresentationModeState = {
  enabled: null,
};

const reducer = createReducer(
  initialPresentationModeState,
  on(FeatureActions.initPresentationMode, (state, { isPresentationMode }) => ({
    ...state,
    enabled: isPresentationMode,
  })),
  on(FeatureActions.togglePresentationMode, state => ({
    ...state,
    enabled: !state.enabled,
  }))
);

export function presentationModeReducer(
  state: PresentationModeState | undefined,
  action: Action
): PresentationModeState {
  return reducer(state, action);
}
